import React from 'react';
import AnalystCornerContent from './AnalystCornerContent';

/**
 * AnalystCorner - Main hub for analyst insights
 * Shows performance scores, historical targets, revisions, grades, and dispersion analysis
 */
export const AnalystCorner: React.FC = () => {
  return <AnalystCornerContent />;
};

export default AnalystCorner;
